import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';

export default function DatabaseConnectionTest() {
  const [connectionStatus, setConnectionStatus] = useState<'checking' | 'connected' | 'error'>('checking');
  const [userCount, setUserCount] = useState<number>(0);
  const [stampCount, setStampCount] = useState<number>(0);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    testConnection();
  }, []);

  const testConnection = async () => {
    try {
      setConnectionStatus('checking');
      setError(null);

      // Test users table
      const { data: users, error: usersError } = await supabase
        .from('users')
        .select('id', { count: 'exact' });

      if (usersError) throw usersError;

      // Test stamps table
      const { data: stamps, error: stampsError } = await supabase
        .from('stamps')
        .select('id', { count: 'exact' });

      if (stampsError) throw stampsError;

      setUserCount(users?.length || 0);
      setStampCount(stamps?.length || 0);
      setConnectionStatus('connected');
    } catch (err) {
      console.error('Database connection test failed:', err);
      setError(err instanceof Error ? err.message : 'Unknown error');
      setConnectionStatus('error');
    }
  };

  const getStatusColor = () => {
    switch (connectionStatus) {
      case 'checking': return '#ffa500';
      case 'connected': return '#00aa00';
      case 'error': return '#ff0000';
      default: return '#666666';
    }
  };

  const getStatusText = () => {
    switch (connectionStatus) {
      case 'checking': return '接続確認中...';
      case 'connected': return '接続成功';
      case 'error': return '接続エラー';
      default: return '不明';
    }
  };

  return (
    <div style={{ 
      position: 'fixed',
      top: 10,
      right: 10,
      background: 'white',
      border: '1px solid #e0e0e0',
      borderRadius: 8,
      padding: 12,
      fontSize: 12,
      zIndex: 1000,
      minWidth: 200,
      boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
      display: 'none'
    }}>
      <div style={{ marginBottom: 8 }}>
        <strong>Supabase接続状況</strong>
      </div>
      <div style={{ color: getStatusColor(), marginBottom: 4 }}>
        ● {getStatusText()}
      </div>
      {connectionStatus === 'connected' && (
        <>
          <div>ユーザー数: {userCount}</div>
          <div>スタンプ数: {stampCount}</div>
        </>
      )}
      {connectionStatus === 'error' && error && (
        <div style={{ color: '#ff0000', fontSize: 10, marginTop: 4 }}>
          {error}
        </div>
      )}
      <button
        onClick={testConnection}
        style={{
          marginTop: 8,
          padding: '4px 8px',
          fontSize: 10,
          background: '#f5f5f5',
          border: '1px solid #e0e0e0',
          borderRadius: 4,
          cursor: 'pointer'
        }}
      >
        再テスト
      </button>
    </div>
  );
}